import React, { useMemo, useState } from 'react';
import api from '../services/api';
import './ForcePasswordReset.css';

function ForcePasswordReset({ onComplete }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const passwordPolicyMessage = useMemo(() => 'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.', []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const trimmedPassword = String(password || '').trim();
    const strongPassword = trimmedPassword.length >= 8
      && /[A-Z]/.test(trimmedPassword)
      && /[a-z]/.test(trimmedPassword)
      && /\d/.test(trimmedPassword)
      && /[^A-Za-z0-9]/.test(trimmedPassword);

    if (!strongPassword) {
      setError(passwordPolicyMessage);
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const data = await api.updateMyPassword(trimmedPassword);
      const currentUser = api.getCurrentUser() || {};
      const updatedUser = data?.user || { ...currentUser, force_password_reset: false };
      onComplete(updatedUser);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="force-reset">
      <div className="force-reset-card">
        <h2>Set a new password</h2>
        <p>Your primary owner account requires a password change before continuing.</p>
        <p className="helper-text">{passwordPolicyMessage}</p>
        <form onSubmit={handleSubmit}>
          <label>
            New password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
              required
            />
          </label>
          <label>
            Confirm password
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Re-enter password"
              required
            />
          </label>
          {error && <div className="error-text">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForcePasswordReset;
